import { NgModule } from '@angular/core';
import { SsLoaderComponent } from './ss-loader.component';
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';



@NgModule({
  declarations: [SsLoaderComponent],
  imports: [
    CommonModule,
    BrowserModule
  ],
  exports: [SsLoaderComponent]
})
export class SsLoaderModule { }
